/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseEcoMileageResponseCheckLinkRtnData } from '../models/ApiResponseEcoMileageResponseCheckLinkRtnData';
import type { ApiResponseEcoMileageResponseGetMemberInfoRtnData } from '../models/ApiResponseEcoMileageResponseGetMemberInfoRtnData';
import type { ApiResponseEcoMileageResponseGetMemberPointInfoRtnData } from '../models/ApiResponseEcoMileageResponseGetMemberPointInfoRtnData';
import type { ApiResponseEcoMileageResponseInfoLinkRtnData } from '../models/ApiResponseEcoMileageResponseInfoLinkRtnData';
import type { ApiResponseEcoMileageResponseInfoMileageRtnData } from '../models/ApiResponseEcoMileageResponseInfoMileageRtnData';
import type { ApiResponseEcoMileageResponseVoid } from '../models/ApiResponseEcoMileageResponseVoid';
import type { ApiResponseListSeoulMileageNotificationResponse } from '../models/ApiResponseListSeoulMileageNotificationResponse';
import type { ApiResponseSeoulMileageAgreementResponse } from '../models/ApiResponseSeoulMileageAgreementResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateSeoulAgreementRequest } from '../models/CreateSeoulAgreementRequest';
import type { UpdateNotificationRequest } from '../models/UpdateNotificationRequest';
import type { UpdateSeasonLinkRequest } from '../models/UpdateSeasonLinkRequest';
import type { UpdateVehicleLinkRequest } from '../models/UpdateVehicleLinkRequest';
import type { WithdrawSeoulAgreementRequest } from '../models/WithdrawSeoulAgreementRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EcoMileageControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 실적(정기,안전운전점수) 업데이트
   * @returns ApiResponseEcoMileageResponseVoid OK
   * @throws ApiError
   */
  public updateVehicleLink({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: UpdateVehicleLinkRequest,
  }): CancelablePromise<ApiResponseEcoMileageResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/vehicle-link',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 실적(정기,안전운전점수) 업데이트
   * @returns ApiResponseEcoMileageResponseVoid OK
   * @throws ApiError
   */
  public updateVehicleLink1({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: UpdateVehicleLinkRequest,
  }): CancelablePromise<ApiResponseEcoMileageResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/vehicle-link/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 실적(계절) 업데이트
   * @returns ApiResponseEcoMileageResponseVoid OK
   * @throws ApiError
   */
  public updateSeasonLink({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: UpdateSeasonLinkRequest,
  }): CancelablePromise<ApiResponseEcoMileageResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/season-link',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 실적(계절) 업데이트
   * @returns ApiResponseEcoMileageResponseVoid OK
   * @throws ApiError
   */
  public updateSeasonLink1({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: UpdateSeasonLinkRequest,
  }): CancelablePromise<ApiResponseEcoMileageResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/season-link/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 마일리지 관련 알림 조회
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateNotification({
    authorization,
    vin,
    notificationId,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    notificationId: number,
    requestBody: UpdateNotificationRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/notifications/{notificationId}/',
      path: {
        'vin': vin,
        'notificationId': notificationId,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 마일리지 관련 알림 조회
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateNotification1({
    authorization,
    vin,
    notificationId,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    notificationId: number,
    requestBody: UpdateNotificationRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/seoul-ecomileage/vehicles/{vin}/notifications/{notificationId}',
      path: {
        'vin': vin,
        'notificationId': notificationId,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 서울시 마일리지 동의 철회
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public withdraw({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: WithdrawSeoulAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/seoul-ecomileage/vehicles/{vin}/withdraw/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 서울시 마일리지 동의 철회
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public withdraw1({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: WithdrawSeoulAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/seoul-ecomileage/vehicles/{vin}/withdraw',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 서울시 에코 마일리지 동의정보 조회
   * @returns ApiResponseSeoulMileageAgreementResponse OK
   * @throws ApiError
   */
  public getAgree({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseSeoulMileageAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/agree',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 서울시 에코 마일리지 동의
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public agree({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: CreateSeoulAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/seoul-ecomileage/vehicles/{vin}/agree',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 서울시 에코 마일리지 동의정보 조회
   * @returns ApiResponseSeoulMileageAgreementResponse OK
   * @throws ApiError
   */
  public getAgree1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseSeoulMileageAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/agree/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 서울시 에코 마일리지 동의
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public agree1({
    authorization,
    vin,
    requestBody,
  }: {
    authorization?: string,
    vin: string,
    requestBody: CreateSeoulAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/seoul-ecomileage/vehicles/{vin}/agree/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 모달 알림 상태 조회
   * @returns ApiResponseListSeoulMileageNotificationResponse OK
   * @throws ApiError
   */
  public getNotifications({
    authorization,
    vin,
    nowDrvngRgsde,
  }: {
    authorization?: string,
    vin: string,
    nowDrvngRgsde?: string,
  }): CancelablePromise<ApiResponseListSeoulMileageNotificationResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/notifications',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'nowDrvngRgsde': nowDrvngRgsde,
      },
    });
  }
  /**
   * 모달 알림 상태 조회
   * @returns ApiResponseListSeoulMileageNotificationResponse OK
   * @throws ApiError
   */
  public getNotifications1({
    authorization,
    vin,
    nowDrvngRgsde,
  }: {
    authorization?: string,
    vin: string,
    nowDrvngRgsde?: string,
  }): CancelablePromise<ApiResponseListSeoulMileageNotificationResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/notifications/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'nowDrvngRgsde': nowDrvngRgsde,
      },
    });
  }
  /**
   * 통합에코 사용가능 마일리지 조회
   * @returns ApiResponseEcoMileageResponseGetMemberPointInfoRtnData OK
   * @throws ApiError
   */
  public getMemberPointInfo({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseGetMemberPointInfoRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/member-point-info/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 통합에코 사용가능 마일리지 조회
   * @returns ApiResponseEcoMileageResponseGetMemberPointInfoRtnData OK
   * @throws ApiError
   */
  public getMemberPointInfo1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseGetMemberPointInfoRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/member-point-info',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 통합 에코 회원 여부 조회
   * @returns ApiResponseEcoMileageResponseGetMemberInfoRtnData OK
   * @throws ApiError
   */
  public getMemberInfo({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseGetMemberInfoRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/member-info',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 통합 에코 회원 여부 조회
   * @returns ApiResponseEcoMileageResponseGetMemberInfoRtnData OK
   * @throws ApiError
   */
  public getMemberInfo1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseGetMemberInfoRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/member-info/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 승용차 마일리지 지급 내역 조회
   * @returns ApiResponseEcoMileageResponseInfoMileageRtnData OK
   * @throws ApiError
   */
  public getInfoMileage({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseInfoMileageRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/info-mileage/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 승용차 마일리지 지급 내역 조회
   * @returns ApiResponseEcoMileageResponseInfoMileageRtnData OK
   * @throws ApiError
   */
  public getInfoMileage1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseInfoMileageRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/info-mileage',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 실적업데이트 조회
   * 에코마일리지 실적업데이트 내용을 조회합니다.
   * @returns ApiResponseEcoMileageResponseInfoLinkRtnData OK
   * @throws ApiError
   */
  public getInfoLink({
    vin,
    odometer,
  }: {
    vin: string,
    odometer?: number,
  }): CancelablePromise<ApiResponseEcoMileageResponseInfoLinkRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/info-link',
      path: {
        'vin': vin,
      },
      query: {
        'odometer': odometer,
      },
    });
  }
  /**
   * 실적업데이트 조회
   * 에코마일리지 실적업데이트 내용을 조회합니다.
   * @returns ApiResponseEcoMileageResponseInfoLinkRtnData OK
   * @throws ApiError
   */
  public getInfoLink1({
    vin,
    odometer,
  }: {
    vin: string,
    odometer?: number,
  }): CancelablePromise<ApiResponseEcoMileageResponseInfoLinkRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/info-link/',
      path: {
        'vin': vin,
      },
      query: {
        'odometer': odometer,
      },
    });
  }
  /**
   * 승용차 마일리지 연계 가능 여부 조회
   * @returns ApiResponseEcoMileageResponseCheckLinkRtnData OK
   * @throws ApiError
   */
  public checkLink({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseCheckLinkRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/check-link',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 승용차 마일리지 연계 가능 여부 조회
   * @returns ApiResponseEcoMileageResponseCheckLinkRtnData OK
   * @throws ApiError
   */
  public checkLink1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseEcoMileageResponseCheckLinkRtnData> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/seoul-ecomileage/vehicles/{vin}/check-link/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
}
